import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { AdminShadcnComponentsJson } from '@cli-types/next-adapter/commands.js'
import { toPosixPath } from '@cli-utils/paths.js'
import { resolveAdminNamespace } from '@next-adapter/config/namespace/resolve-admin-namespace.js'
export function createAdminShadcnComponentsJson(
  config: ResolvedBetterstartConfig
): AdminShadcnComponentsJson {
  const adminPath = toPosixPath(config.paths.admin)
  const namespace = resolveAdminNamespace(config.frameworkConfig.next.namespace)

  return {
    $schema: 'https://ui.shadcn.com/schema.json',
    base: 'base',
    style: 'maia',
    rsc: true,
    tsx: true,
    tailwind: {
      config: '',
      css: `${adminPath}/${namespace.globalsFile}`,
      baseColor: 'neutral',
      cssVariables: true,
      prefix: ''
    },
    iconLibrary: 'lucide',
    aliases: {
      components: `${namespace.alias}/components`,
      ui: `${namespace.alias}/components/ui`,
      hooks: `${namespace.alias}/hooks`,
      lib: `${namespace.alias}/lib`,
      utils: `${namespace.alias}/utils/shared/cn`
    }
  }
}
